// extracted by mini-css-extract-plugin
export default {"heading":"heroImage_heading__nSmR3","subheader-space":"heroImage_subheader-space__iM18L","heading-space":"heroImage_heading-space__gPmbn","hero-image":"heroImage_hero-image__VGfZv"};